import { render } from "./ImgEmptyTips.vue?vue&type=template&id=05e72e22&scoped=true"
import script from "./ImgEmptyTips.vue?vue&type=script&lang=js"
export * from "./ImgEmptyTips.vue?vue&type=script&lang=js"

import "./ImgEmptyTips.vue?vue&type=style&index=0&id=05e72e22&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e72e22"]])

export default __exports__